import { styled } from '@ori-ui/mui';

export const Root = styled('p')(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: theme.typography.pxToRem(20),
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: '29px',
  margin: theme.spacing(0, 0, 6),
  textAlign: 'center',
}));
